<template>
  <div class="field-group">
    <label :for="controlId" v-bind:class="{ animated: animatedLabel, hasContent: hasSelectedValue }" v-if="label">
      <span class="fixed-label">{{ label }}</span>
      <span class="animated-label">{{ label }}</span>
    </label>
    <input
      type="text"
      ref="input"
      class="fill-width"
      :name="controlId"
      :id="controlId"
      v-model="formValue"
      v-on:input="debounceInput($event)"
      :placeholder="label"
      :readonly="readOnly"
    />
  </div>
</template>
<script>
export default {
  name: 'form-input',
  model: {
    event: 'value-changed',
  },
  data() {
    return {
      formValue: this.value,
    }
  },
  methods: {
    // Wait for the user to stop typing for specified milliseconds before processing the change
    debounceInput: _.debounce(function (event) {
      this.$emit('value-changed', this.$refs.input.value)
    }, 750),

    clear() {
      this.formValue = null
    },
  },
  computed: {
    controlId() {
      // return `${this.idPrefix}${this.id}${this.idSuffix}`
      return this.idPrefix + this.id + this.idSuffix
    },

    hasSelectedValue() {
      return this.formValue && this.formValue !== '0'
    },
  },
  watch: {
    value() {
      this.formValue = this.value
    },
  },
  props: {
    animatedLabel: {
      type: Boolean,
      default: true,
    },

    id: {
      default: '0',
    },

    idPrefix: {
      default: 'product_attribute_',
    },

    idSuffix: {
      default: '',
    },

    label: {
      required: false,
    },

    placeholder: {
      required: false,
    },

    readOnly: {
      required: false,
      default: false,
    },

    value: {
      required: true,
    },
  },
}
</script>
